import script from "./Pagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=ts"

import "./Pagination.vue?vue&type=style&index=0&id=024960ea&scoped=true&lang=css"

import exportComponent from "/Users/BlackPaw/Developer/acebed_vue3_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-024960ea"]])

export default __exports__